import TrouverSyndicatButton from "./TrouverSyndicatButton";
import { MapPin, UsersRound } from "lucide-react";
import logoSna from "../../assets/img/logo-sna-transparent.png";

const PasDeSyndicat = () => {
  return (
    <section className='overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_18px_55px_-35px_rgba(15,23,42,0.45)]'>
      <div className='flex min-h-20 items-center justify-between gap-5 border-b border-slate-100 bg-[#fbfaf6] px-5 py-4 sm:px-7 lg:px-8'>
        <div className='flex items-center gap-3'>
          <div className='flex h-10 w-10 items-center justify-center rounded-xl bg-[#f1e8c9] text-[#755c14]'>
            <UsersRound className='h-5 w-5' />
          </div>
          <div>
            <p className='font-bold text-slate-950'>Structure départementale</p>
          </div>
        </div>
        <img
          className='hidden h-12 w-auto object-contain sm:block'
          src={logoSna}
          alt="Syndicat national d'apiculture"
        />
      </div>

      <div className='grid gap-7 p-5 sm:p-7 lg:grid-cols-[minmax(0,1fr)_19rem] lg:gap-10 lg:p-8'>
        <div className='self-center'>
          <h2 className='text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl'>Aucun syndicat associé</h2>
          <p className='mt-3 max-w-2xl text-sm leading-6 text-slate-600 sm:text-base'>
            Rejoindre un syndicat permet d'être accompagné localement, de rencontrer d'autres apiculteurs et de
            participer à la vie du réseau.
          </p>
        </div>

        <aside className='relative overflow-hidden rounded-2xl bg-[#173f35] p-6 text-white shadow-[0_18px_45px_-28px_rgba(23,63,53,0.9)]'>
          <div className='absolute -right-12 -top-12 h-36 w-36 rounded-full border border-[#d7b64d]/30' />
          <div className='relative'>
            <MapPin className='h-7 w-7 text-[#f4d56f]' />
            <h3 className='mt-6 text-xl font-bold'>Près de chez vous</h3>
            <p className='mt-2 text-sm leading-6 text-emerald-50/80'>
              Recherchez les syndicats affiliés dans votre département.
            </p>
            <div className='mt-6'>
              <TrouverSyndicatButton />
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default PasDeSyndicat;
